import React from "react"
import { Link } from "react-router-dom"
import Footer from "../components/footer"
import Navbar from "../components/nav"

function AiSmartGalleryTerms() {
  return (
    <>
      <header className="header-area">
        <div className="navbar-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Navbar />
              </div>
            </div>
          </div>
        </div>
      </header>

      <div id="home">
        <div className="container mt-125 mb-50">
          <div className="card-body shadow">
            <h4>Terms &amp; Conditions - AI Smart Gallery</h4>
            <br />
            <ul>
              <li>THE DEVELOPER = MWX Apps</li>
              <li>THE APP = AI Smart Gallery: Photo Search</li>
              <li>PACKAGE = mwxapps.smart.gallery</li>
            </ul>
            <br />
            <p>
              By downloading or using THE APP, these terms will automatically apply
              to you – you should make sure therefore that you read them carefully
              before using THE APP. You're not allowed to copy, or modify THE APP,
              any part of THE APP, or our trademarks in any way. You're not allowed
              to attempt to extract the source code of THE APP, and you also
              shouldn't try to translate THE APP into other languages, or make
              derivative versions. THE APP itself, and all the trade marks,
              copyright, database rights and other intellectual property rights
              related to it, still belong to THE DEVELOPER.
            </p>
            <p>
              THE DEVELOPER is committed to ensuring that THE APP is as useful and
              efficient as possible. For that reason, we reserve the right to make
              changes to THE APP or to charge for its services, at any time and for
              any reason. We will never charge you for THE APP or its services
              without making it very clear to you exactly what you're paying for.
            </p>

            <br />
            <strong>Your Content and Your Device</strong>
            <p>
              AI Smart Gallery is a gallery for the photos and videos already on your
              device, and its AI features — search, faces, captions, object tags,
              smart albums and the cleaner — run <strong>entirely on your
              device</strong>. You are responsible for the media you choose to
              access, hide, move or delete, and for keeping backups of anything
              important. Some actions (move, rename, delete, trash) change files on
              your device; Android asks you to confirm each change unless you enable
              "Media management". THE DEVELOPER is not responsible for files you
              change or remove through THE APP.
            </p>
            <p>
              The vault encrypts items with AES-256 using a key derived from your PIN
              or password. If you forget that PIN or password, vault items cannot be
              recovered. Vault items are deleted if you uninstall THE APP or clear
              its data.
            </p>

            <br />
            <strong>Third-Party Services</strong>
            <p>
              THE APP uses third-party services only to deliver and support it:
            </p>
            <ul>
              <li><strong>Google Play Services</strong> – https://policies.google.com/terms</li>
              <li><strong>Google Play</strong> – delivers AI model downloads. No photo or personal data is sent in this process</li>
              <li><strong>Cloud storage you connect yourself (e.g. Dropbox)</strong> – optional; the app talks directly to the provider you choose, and that provider's terms and privacy policy apply to files stored there</li>
              <li><strong>Google AdMob</strong> – will serve the ads that keep THE APP free. See <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">Google's Advertising Policies</a></li>
            </ul>
            <p>
              Your use of data from these services is subject to their respective
              terms and privacy policies. We have no control over and assume no
              responsibility for their content, availability or practices. THE APP
              does <strong>NOT</strong> use Google Analytics, Firebase Analytics or
              the Facebook SDK.
            </p>
            <p>
              <strong>Advertising:</strong> Advertising is being introduced in an
              upcoming version of THE APP through Google AdMob. Once enabled, ads
              may be personalised based on your resettable Android Advertising ID
              where you have consented. You can reset or delete this ID at any time
              in <em>Android Settings → Google → Ads</em>, and change your consent
              choice from the app's settings. Advertising does not change how the AI
              works — your photos, the AI index and the vault always stay on your
              device. Full details are in our
              <Link to="/AiSmartGallery/privacy-policy" style={{ color: "#0898e7", fontWeight: "600" }}>Privacy Policy</Link>.
            </p>

            <br />
            <strong>Internet and Device Requirements</strong>
            <p>
              The on-device AI features work without an internet connection. A
              connection (Wi-Fi or mobile data) is needed only to download the AI
              models from Google Play, to look up place names through Android's
              geocoder, and to sync any cloud storage you connect yourself. THE
              DEVELOPER cannot take responsibility for THE APP not working at full
              functionality if you lack connectivity or data allowance. If you use
              THE APP outside Wi-Fi, your mobile provider's terms and charges apply,
              including roaming charges. You are responsible for such charges.
            </p>
            <p>
              It's your responsibility to keep your phone and access to THE APP
              secure. We recommend that you do not jailbreak or root your phone, as
              it could make your device vulnerable to malware and cause THE APP to
              malfunction. Keep your device charged – THE DEVELOPER cannot be
              responsible if you cannot access THE APP due to battery loss.
            </p>

            <br />
            <strong>Privacy</strong>
            <p>
              Your privacy is important to us. Our collection and use of information
              is governed by our{" "}
              <Link to="/AiSmartGallery/privacy-policy" style={{ color: "#0898e7", fontWeight: "600" }}>
                Privacy Policy
              </Link>
              . By using THE APP you consent to the practices described therein.
              Key points: no account, no analytics, no crash
              reporting; photos, the AI index and the vault stay on your device.
            </p>

            <br />
            <strong>Disclaimers and Warranties</strong>
            <p>
              THE APP IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT
              WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
              LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
              PARTICULAR PURPOSE, NON-INFRINGEMENT OR COURSE OF PERFORMANCE. THE
              DEVELOPER does not warrant that THE APP will be uninterrupted,
              error-free, secure or that defects will be corrected. AI results
              (search, faces, captions and tags) are generated automatically and may
              be incomplete or inaccurate.
            </p>

            <br />
            <strong>Limitation of Liability</strong>
            <p>
              TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
              THE DEVELOPER, ITS DIRECTORS, EMPLOYEES, PARTNERS, AGENTS, SUPPLIERS OR
              AFFILIATES BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
              CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION LOSS OF
              PROFITS, DATA, USE, GOODWILL OR OTHER INTANGIBLE LOSSES, RESULTING FROM
              (a) YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE APP;
              (b) LOSS OF OR DAMAGE TO PHOTOS, VIDEOS OR OTHER FILES; (c) ANY
              CONTENT OBTAINED FROM THE APP; (d) UNAUTHORIZED ACCESS OR ALTERATION;
              (e) RELIANCE ON AI RESULTS SUCH AS SEARCH, FACE GROUPS, CAPTIONS OR
              TAGS.
            </p>

            <br />
            <strong>Updates and Termination</strong>
            <p>
              At some point, we may wish to update THE APP. THE APP is currently
              available on Android – the requirements for system (and for any
              additional systems we decide to extend the availability of THE APP to)
              may change, and you'll need to download the updates if you want to keep
              using THE APP. THE DEVELOPER does not promise that it will always
              update THE APP so that it is relevant to you and/or works with the
              Android version that you have installed on your device. However, you
              promise to always accept updates to THE APP when offered to you. We may
              also wish to stop providing THE APP, and may terminate use of it at any
              time without giving notice of termination to you. Unless we tell you
              otherwise, upon any termination, (a) the rights and licenses granted to
              you in these terms will end; (b) you must stop using THE APP, and (if
              needed) delete it from your device.
            </p>

            <br />
            <strong>Governing Law</strong>
            <p>
              These Terms shall be governed and construed in accordance with the laws
              of Turkey, without regard to its conflict of law provisions. Any disputes
              shall be submitted to the competent courts of Turkey.
            </p>

            <br />
            <strong id="changes-to-these-terms-and-conditions">
              <a
                aria-hidden="true"
                href="#changes-to-these-terms-and-conditions"
                tabIndex="-1"
              >
                <span className="icon icon-link"></span>
              </a>
              Changes to These Terms and Conditions
            </strong>
            <p>
              We may update our Terms and Conditions from time to time. Thus, you are
              advised to review this page periodically for any changes. We will
              notify you of any changes by updating the "Last Updated" date. These changes
              are effective immediately after they are posted on this page.
              This policy is effective as of September 25, 2026.
            </p>

            <br />
            <strong id="contact-us">
              <a aria-hidden="true" href="#contact-us" tabIndex="-1">
                <span className="icon icon-link"></span>
              </a>
              Contact Us
            </strong>
            <p>
              If you have any questions or suggestions about these Terms and
              Conditions, do not hesitate to contact us at: web-developer@outlook.com
            </p>
            <p className="mt-2"><strong>Developer:</strong> MWX Apps</p>
            <p><strong>App:</strong> AI Smart Gallery: Photo Search (mwxapps.smart.gallery)</p>
            <p><strong>Website:</strong> https://mwx-apps.web.app/AiSmartGallery</p>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default AiSmartGalleryTerms